module.exports = __webpack_public_path__ + "img/r-186.4496eca8.jpg";